import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import DataGrid from "../../form/SelectorGrid/DataGrid";
import {list} from "../../../utils/array";
import {CurrencyFormatter, NumberEditable} from "../../../utils/table";
import Confirm from "../../form/Confirm";
import Button from "../../form/Button";
import {set} from "../../../utils/dotutils";
import TicketPriceEditor from "../TicketPriceEditor";
import ModalEditor from "../ModalEditor";
import FragmentEditor from "../FragmentEditor";
import {loadComponent} from "../../../utils/components";
import {UnitFormatter} from "../../../utils/formatters";

class PriceRows extends React.Component {
    render() {
        const prices = this.props.data.items || [];
        return (
            <div className="prices">
                {prices.map((price, idx) => {
                    return <div key={idx} className="ticket">
                        <div className="ticket_content">
                            <div className="ticket_header">
                                <div className="ticket_id">{price.id}</div>
                                <div className="ticket_actions">
                                    {price.id || Object.values(price).some((v) => !!v) ? <Confirm
                                        header="Törlés"
                                        body="Biztosan törlöd ezt a tételt?"
                                        acceptButton="Törlés"
                                        color="danger"
                                        timeout={3}
                                        buttonSize="xs"
                                        icon={{lib: "fa", name: "times"}}
                                        onAccept={() => {
                                            this.props.removeItems(price.id ? [{id: price.id}] : [{idx}]);
                                        }}
                                    /> : <Button
                                        size="xs"
                                        icon={{lib: "fa", name: "times"}}
                                        onClick={() => {
                                            this.props.removeItems([{idx}]);
                                        }}
                                    />}
                                </div>
                            </div>
                            <div className="form-group limit">
                                <TextInput
                                    name="limit"
                                    className="limit"
                                    label="Fő felett"
                                    value={price.limit}
                                    saveChanges={(field, value) => {
                                        let newData = {...price};
                                        set(newData, field, value);
                                        this.props.editItems([newData]);
                                    }}
                                />
                            </div>
                            <div className="form-group advance_payment_price">
                                <TextInput
                                    name="advance_payment_price"
                                    type="number"
                                    className="advance_payment_price"
                                    label="Előleg összege"
                                    value={price.advance_payment_price}
                                    saveChanges={(field, value) => {
                                        if (!value) {
                                            value = null;
                                        }
                                        let newData = {...price};
                                        set(newData, field, value);
                                        this.props.editItems([newData]);
                                    }}
                                />
                            </div>
                            <div className="form-group ticket_price">
                                <TextInput
                                    type="number"
                                    className="ticket_price"
                                    label={this.props.groupPrices ? "Csoportos ár" : "Ár (fejenként)"}
                                    name={this.props.groupPrices ? "group_price" : "price"}
                                    value={price[this.props.groupPrices ? "group_price" : "price"]}
                                    saveChanges={(field, value) => {
                                        let newData = {...price};
                                        set(newData, field, value);
                                        this.props.editItems([newData]);
                                    }}
                                />
                            </div>
                        </div>
                    </div>;
                })}
            </div>
        );
    }
}

class FilteredPrices extends React.Component {
    render() {
        let props = {};
        const filter = list(this.props.filter);
        if (this.props.values[this.props.componentConfig.idfield]) {
            props.component = "TicketPrice";
            filter.push({
                field: "ticket_type",
                value: this.props.values[this.props.componentConfig.idfield]
            });
        } else {
            props.value = this.props.values.prices || [];
            props.removeItems = (items, props) => {
                items = items.map((data) => data.idx);
                this.props.setFieldValue("prices", props.value.filter(function(value, index) {
                    return items.indexOf(index) === -1;
                }));
                this.list && this.list.refresh();
            }
        }
        if (this.props.groupPrices) {
            filter.push({
                field: "group_price",
                operator: "not isnull"
            })
        } else {
            filter.push({
                field: "group_price",
                operator: "isnull"
            });
        }
        return (
            <DataGrid
                ref={(list) => this.list = list}
                pageSize={0}
                {...props}
                filter={filter}
                type={PriceRows}
                groupPrices={this.props.groupPrices}
                order={{field: "limit", direction: "DESC"}}
            >
                <Field
                    sortable={true}
                    filterable={true}
                    field={this.props.componentConfig.idfield}
                    header="Kód"
                />
                <Field
                    sortable={true}
                    filterable={true}
                    field="limit"
                    header="Fő felett"
                    editable={<NumberEditable />}
                >
                </Field>
                {!this.props.groupPrices && <Field
                    sortable={true}
                    filterable={true}
                    field="price"
                    header="Ár (fejenként)"
                    editable={<NumberEditable />}
                    formatter={<CurrencyFormatter />}
                />}
                {this.props.groupPrices && <Field
                    sortable={true}
                    filterable={true}
                    field="group_price"
                    header="Csoportos ár"
                    editable={<NumberEditable />}
                    formatter={<CurrencyFormatter />}
                />}
                <Field
                    sortable={true}
                    filterable={true}
                    field="advance_payment_price"
                    header="Előleg összege"
                    editable={<NumberEditable />}
                    formatter={<CurrencyFormatter />}
                />
                <Field
                    sortable={true}
                    filterable={true}
                    field="currency"
                    header="Pénznem"
                />
            </DataGrid>
        );
    }
}

class Prices extends React.Component {
    render() {
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Jegyárak</label>
                            <FilteredPrices {...this.props} groupPrices={false} />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Csoportos jegyárak</label>
                            <FilteredPrices {...this.props} groupPrices={true} />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

class TicketTypeForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                    </div>
                    {/* <div className="col-md-4">
                        <Select
                            component="Program"
                            name="program"
                            value={this.props.values.program}
                            label="Program"
                            labelKey="name"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("program")}
                        />
                    </div> */}
                    <div className="col-md-6">
                        <div className="form-group">
                            <TextInput
                                name="name"
                                value={this.props.values.name}
                                label="Jegytípus elnevezés"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("name")}
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group unit">
                            <TextInput
                                name="max_qty"
                                type="number"
                                value={this.props.values.max_qty}
                                label="Vásárolható mennyiség"
                                formatter={UnitFormatter}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("max_qty")}
                            />
                        </div>
                    </div>
                    {!!this.props.values[this.props.componentConfig.idfield] && <div className="col-md-2">
                        <div className="form-group unit">
                            <TextInput
                                name="max_qty"
                                type="number"
                                value={this.props.values.purchased_qty}
                                label="Vásárolt mennyiség"
                                formatter={UnitFormatter}
                                {...this.props.getFieldProps("purchased_qty")}
                                disabled={true}
                            />
                        </div>
                    </div>}
                </div>
                {/*<Prices {...this.props} filter={[]} />*/}
                {!!this.props.values[this.props.componentConfig.idfield] && <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Jegyárak</label>
                            <TicketPriceEditor
                                editorContext="TicketTypeTicketPriceSingle"
                                presets={{ticket_type: this.props.values[this.props.componentConfig.idfield]}}
                                listFilter={{
                                    field: "ticket_type",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }}
                                list={FragmentEditor}
                                editor={ModalEditor}
                                groupPrices={false}
                            />
                        </div>
                    </div>
                </div>}
                {!!this.props.values[this.props.componentConfig.idfield] && <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Csoportos jegyárak</label>
                            <TicketPriceEditor
                                editorContext="TicketTypeTicketPriceGroup"
                                presets={{ticket_type: this.props.values[this.props.componentConfig.idfield]}}
                                listFilter={{
                                    field: "ticket_type",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }}
                                list={FragmentEditor}
                                editor={ModalEditor}
                                groupPrices={true}
                            />
                        </div>
                    </div>
                </div>}
            </form>
        );
    }
}

export default createForm(TicketTypeForm);
